import {
  badWords,
  disallowInsecureCharacters,
  required,
} from '@seek/validators-js';
import { Heading, Stack, TextField } from 'braid-design-system';
import React from 'react';

import { withoutHighlight } from 'src/utils';

import { useField } from '../../utils';

const UserName = () => {
  const firstName = withoutHighlight(
    useField({
      id: 'firstName',
      validators: [required, badWords, disallowInsecureCharacters],
    }),
  );

  const lastName = withoutHighlight(
    useField({
      id: 'lastName',
      validators: [required, badWords, disallowInsecureCharacters],
    }),
  );

  return (
    <Stack space="large">
      <Heading level="3" component="h2">
        What&apos;s your name?
      </Heading>
      <Stack space="medium">
        <TextField
          id="firstName"
          type="text"
          label="First name"
          onChange={firstName.onChange}
          value={firstName.value}
          tone={firstName.valid ? 'neutral' : 'critical'}
          message={!firstName.valid && firstName.errorMessage}
        />
        <TextField
          id="lastName"
          type="text"
          label="Last name"
          onChange={lastName.onChange}
          value={lastName.value}
          tone={lastName.valid ? 'neutral' : 'critical'}
          message={!lastName.valid && lastName.errorMessage}
        />
      </Stack>
    </Stack>
  );
};

export default UserName;
